import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';
import { useSpring } from 'framer-motion';
import { API_URL } from '../../../../constants';
import { GetServiceCaller, PostServiceCaller } from '../../../../services/serviceCaller';
import CustomDatePicker from '../../../../components/Custom-Datepicker';
import moment from 'moment';
import Select from "react-select";
import { FaSpinner } from 'react-icons/fa';
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RepairableAssetEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Repairable Assets "))
    }, []);

    const initialFormData = {
        AssetID: id,
        RepairableDate: "",
        AssetName: "",
        RepairCost: "",
        VendorID: "",
        Remarks: "",
        ReceivedDate: "",

        Status: 0

    }

    const [formData, setFormData] = useState(initialFormData);
    const [vendorOption, setVendorOption] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState([])
    useEffect(() => {
        fetchRepairableAssets()
        if (id) {
            fetchRepairableAssetsID(id)
        }
    }, []);

    const fetchRepairableAssets = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}asset-repairable`);
            if (response.status === 200) {
                const cleanedData = response?.data;
                const vendor = cleanedData?.vendorList?.map((ele) => ({
                    value: ele?.value,
                    label: ele?.text
                }))
                setVendorOption(vendor || [])
                setLoading(false);
                setPageLoading(false);
            } else {
                console.error(
                    "Failed to fetch repairable asset api. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching repairable asset api:", error);
        }
    };
    const fetchRepairableAssetsID = async (id) => {
        try {
            const response = await GetServiceCaller(`${API_URL}asset-repairable/${id}`);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                const formDataEdit = {
                    AssetID: cleanedData?.AssetID,
                    AssetName: cleanedData?.AssetName,
                    RepairableDate: cleanedData?.RepairableDate,
                    RepairCost: cleanedData?.RepairCost,
                    ReceivedDate: cleanedData?.ReceivedDate,
                    VendorID: cleanedData?.VendorID,
                    Remarks: cleanedData?.Remarks,
                    ID: cleanedData?.ID,
                    Status: cleanedData?.Status
                }
                setFormData(formDataEdit)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch repairable asset api. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching repairable asset api:", error);
        }
    };


    const schema = Yup.object().shape({
        RepairableDate: Yup.string().required("Repairable Date is required"),
        ReceivedDate: Yup.string().required("Received Date is required"),
        Remarks: Yup.string(),
        RepairCost: Yup.string().required("Repair Cost is required"),
        Remarks: Yup.string().required("Repair Details is required"),
        VendorID: Yup.number()
            .typeError("Vendor  is required")
            .required("Vendor  is required")
        ,
    });

    const validateField = async (fieldName, updatedData) => {
        try {
            // Validate the specific field
            await schema.validateAt(fieldName, updatedData);

            // Clear the error for the specific field if validation is successful
            setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
        } catch (err) {
            if (err.path === fieldName) {
                // Update the error only for the specific field
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: err.message }));

                // Show error using toast for specific fields if needed
                if (fieldName.startsWith("brandsLine")) {
                    toast.error(err.message, { position: "top-right" });
                }
            } else {
                console.error("Validation error structure is not as expected:", err);
            }
        }
    };
    const handleChange = async (event) => {
        const { name, value } = event.target;
        // Update form data only for fields in the schema
        if (schema.fields[name]) {
            setFormData((prevData) => {
                const updatedData = { ...prevData, [name]: value };
                validateField(name, updatedData);
                return updatedData;
            });
        }
    }
    const handleSelect = async (selectedOption, name) => {
        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: selectedOption?.value || ""
            };


            validateField(name, updatedData)
            return updatedData;
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Validate formData using schema
            await schema.validate(formData, { abortEarly: false });
            setErrors({}); // Clear previous errors

            const response = await PostServiceCaller(
                `${API_URL}asset-repairable/${id}`,
                { ...formData, RepairableDate: moment(formData?.RepairableDate).format("YYYY-MM-DD"), 
                    ReceivedDate: moment(formData?.ReceivedDate).format("YYYY-MM-DD")
                 },
                "put"
            );

            if (response.status === 200) {
                toast.success("Data submitted successfully");
                // Redirect after a successful submission
                setTimeout(() => {
                    navigate("/repairable-assets");
                }, 2000);
            } else {
                console.error(
                    "Failed to submit data. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            if (error.name === "ValidationError") {
                const validationErrors = {};
                error.inner.forEach((err) => {
                    validationErrors[err.path] = err.message;
                });
                setErrors(validationErrors);
            } else {
                console.error("Unexpected Error:", error);
            }
        } finally {
            setLoading(false);
        }
    };
    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setFormData({
            ...formData,
            Status: isChecked ? 1 : 0, // Use numbers for consistency
        });
    };


      if (pageLoading) {
        return (
          <>
            <p class="position-absolute top-50 start-50 translate-middle text-center">
              <FaSpinner class="spinner" />
            </p>
          </>
        );
      } else {
        return (
            <>
                <div className="container-fluid " id="skill_section">
                        <form
                            className="rounded mt-2 bg-white"
                            onSubmit={handleSubmit}
                        >
                            <div className="p-2">
                                <div class="card-body  mx-2">
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label class="form-label">
                                                Sent To Repair
                                            </label>
                                            <CustomDatePicker
                                                // handleChange={(e) => handleReqDate(e)}
                                                handleChange={(e) => handleChange(e)}
                                                value={formData.RepairableDate ? moment(formData.RepairableDate).format(
                                                    "DD-MMM-YYYY"
                                                ) : ''}
                                                readOnly={true}
                                                disabled
    
                                                name="RepairableDate"
                                                className="form-control"
                                                placeholderText="DD-MMM-YYYY"
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <label class="form-label">
                                                Sent To Repair
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control`}
                                                name="RepairCost"
                                                disabled
                                                readOnly
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Repair Cost"
                                                value={formData.AssetName}
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <label class="form-label">
                                                Received Date<span className="text-danger">*</span>
                                            </label>
                                            <CustomDatePicker
                                                // handleChange={(e) => handleReqDate(e)}
                                                handleChange={(e) => handleChange(e)}
                                                value={formData.ReceivedDate ? moment(formData.ReceivedDate).format(
                                                    "DD-MMM-YYYY"
                                                ) : ''}
    
                                                name="ReceivedDate"
                                                className={`form-control ${errors.ReceivedDate ? "border border-danger" : ""
                                                }`}
                                                placeholderText="DD-MMM-YYYY"
                                            />
                                               {errors.ReceivedDate && (
                                                    <div className="invalid-feedback" style={{display:"block"}}>{errors.ReceivedDate}</div>
                                                )}
                                        </div>
    
                                    </div>
                                    <div className='row mt-2'>
                                        <div className='col-md-4'>
                                            <label class="form-label">
                                            Repair Cost
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control ${errors.RepairCost ? "is-invalid" : ""
                                                    }`}
                                                name="RepairCost"
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Repair Cost"
                                                value={formData.RepairCost}
                                                readOnly={true}
                                                disabled
                                            />   {errors.RepairCost && (
                                                <div className="invalid-feedback">{errors.RepairCost}</div>
                                            )}
                                        </div>
                                        <div className='col-md-4'>
                                            <label class="form-label">
                                                Vendor
                                            </label>
                                            <Select
                                                name="VendorID"
                                                disabled
                                                onChange={(selectedOption, action) =>
                                                    handleSelect(selectedOption, action.name)
                                                }
                                                value={vendorOption?.find(o => o.value === formData?.VendorID)}
                                                className={`${errors.VendorID ? "is-invalid" : ""
                                                    }`}
                                                isDisabled={true}
                                                options={[
                                                    { value: null, label: "Select" },
                                                    ...vendorOption
                                                ]}
                                            /> {errors.VendorID && (
                                                <div className="invalid-feedback">{errors.VendorID}</div>
                                            )}
                                        </div>
                                        <div className="col-md-4 ">
                                            <label className="form-label">Repair Details<span className="text-danger">*</span></label>
                                            <textarea
                                                placeholder="Repaire Details"
                                                className={`form-control  ${errors.Remarks ? "is-invalid" : ""
                                                    }`}
                                                
                                                name="Remarks"
                                                onChange={(e)=>handleChange(e)}
                                                value={formData.Remarks}
                                            ></textarea> {errors.Remarks && (
                                                <div className="invalid-feedback">
                                                    {errors.Remarks}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-4 d-block">
                                            <label className="form-label me-2">Ready to Use</label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="Status"
                                                checked={formData?.Status === 1} // Ensure `Status` is treated as a number
                                                onChange={handleCheckboxChange} // No need for `(e) =>` wrapper
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="d-flex justify-content-end">
                                            <div className="d-flex">
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="cancel-btn me-2"
                                                        onClick={() => navigate(`/repairable-assets`)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                                <div>
                                                    {
                                                        formData?.Status !== 1 ?
                                                            null
                                                            :
    
                                                            <button
                                                                disabled={loading ? true : false}
                                                                type="submit"
                                                                className="custom-btn"
                                                            >
                                                                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                                                            </button>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                </div>
            </>
        )
      }

}

export default RepairableAssetEdit